import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-change-the-owner-of-policy'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Change the Owner of your Policy
        </Typography>
        <Typography nextElement='typography'>
          Changes in your personal life may create the need to change the policyowner. There may also be tax or
          legal advantages to having your life insurance policies owned by a trust, or by other family members
          who will be the beneficiaries.
        </Typography>
        <Typography nextElement='typography'>
          The decision to change the policyowner should not be taken lightly. Before requesting
          a form, contact your Northwestern Mutual representative, attorney, or other advisors to discuss
          the ramifications.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          &#34;Policyowner&#34; Defined
        </Typography>
        <Typography nextElement='typography'>
          The policyowner is the person or entity who owns an insurance policy and has all
          contractual rights. The policyowner does not have to be the person who is insured or who pays the
          premium, except on a tax&#8211;qualified annuity.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Multiple Policyowners
        </Typography>
        <Typography nextElement='typography'>
          You may name multiple policyowners. All policyowners must act jointly on all policy
          transactions, however, and all their signatures are required on any documents that change the policy.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Death Proceeds
        </Typography>
        <Typography nextElement='typography'>
          Changing the ownership of a policy does not change the beneficiary of the death proceeds.
          To make a change to the beneficiary designation, call your Northwestern Mutual representative or
          contact Northwestern Mutual directly at <Link id='life-insurance-faq-change-beneficiary-number-link' ariaLabel='Call to change the benificiary designation' linkUrl='tel:8003888123' variant='primaryDeemphasize'>1&#45;800&#45;388&#45;8123</Link> <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT. Monday &#8211; Friday.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Change the Owner
        </Typography>
        <Typography nextElement='typography'>
          You may name multiple policyowners. All policyowners must act jointly on all policy
          transactions, however, and all their signatures are required on any documents that change the
          policy.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Multiple Policyowners
        </Typography>
        <Typography disableBottomPadding>
          To change the owner, you will need to complete and sign an owner designation form. Call your
          Northwestern Mutual representative, or contact Northwestern Mutual directly at <Link id='life-insurance-faq-change-policy-owner-number-link' ariaLabel='Call to change the owner and complete the owner designation form' linkUrl='tel:8773949524' variant='primaryDeemphasize'>1&#45;877&#45;394&#45;9524</Link> <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT. Monday &#8211; Friday.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
